function PlanRing({ used, limit }) {
  const size = 36;
  const strokeWidth = 3.5;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const safeMax = limit === -1 ? Math.max(used, 1) : Math.max(limit, 1);
  const offset = circumference * (1 - Math.min(used, safeMax) / safeMax);

  return (
    <div className="relative flex-shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#F3F4F6" strokeWidth={strokeWidth} />
        <circle
          cx={size / 2} cy={size / 2} r={radius} fill="none"
          stroke="#F97316" strokeWidth={strokeWidth}
          strokeDasharray={circumference} strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-[8px] font-bold leading-none text-slate-900">
          {used}/{limit === -1 ? '∞' : limit}
        </span>
      </div>
    </div>
  );
}

export default function PlanBar({
  planName,
  usagePeriodLabel,
  used,
  limit,
  difficultyLevels = [],
  coachModes = [],
  allowBars,
  summaryLevel,
  onUpgrade,
}) {
  const remaining = limit === -1 ? null : Math.max(0, limit - used);
  const availableDifficulty = difficultyLevels.filter((d) => d.available);
  const availableCoach = coachModes.filter((m) => m.available);
  const capitalizedLevel = summaryLevel
    ? summaryLevel.charAt(0).toUpperCase() + summaryLevel.slice(1)
    : null;

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-2xl border border-gray-200 bg-white px-4 py-3 shadow-sm">
      <PlanRing used={used} limit={limit} />

      <div className="min-w-0 flex-1">
        <span className="text-sm font-bold text-slate-900">{planName || 'Current plan'}</span>
        {usagePeriodLabel && (
          <span className="ml-2 text-xs text-gray-500">{usagePeriodLabel}</span>
        )}
      </div>

      <span className="whitespace-nowrap text-sm font-bold text-orange-600">
        {limit === -1 ? 'Unlimited' : `${remaining} left`}
      </span>

      <div className="flex flex-wrap gap-1.5">
        {availableDifficulty.map((d) => (
          <span key={d.name} className="rounded-md border border-orange-200 bg-orange-50 px-2 py-0.5 text-[10px] font-semibold text-orange-700">
            {d.name}
          </span>
        ))}
        {availableCoach.map((m) => (
          <span key={m.id || m.name} className="rounded-md border border-blue-200 bg-blue-50 px-2 py-0.5 text-[10px] font-semibold text-blue-700">
            {m.name}
          </span>
        ))}
        {allowBars && (
          <span className="rounded-md border border-green-200 bg-green-50 px-2 py-0.5 text-[10px] font-semibold text-green-700">
            BARS ✓
          </span>
        )}
        {capitalizedLevel && (
          <span className="rounded-md border border-violet-200 bg-violet-50 px-2 py-0.5 text-[10px] font-semibold text-violet-700">
            Report: {capitalizedLevel}
          </span>
        )}
      </div>

      <button
        type="button"
        onClick={onUpgrade}
        className="flex-shrink-0 rounded-xl bg-orange-500 px-3 py-1.5 text-xs font-bold text-white transition hover:bg-orange-600"
      >
        Upgrade
      </button>
    </div>
  );
}
